var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMn = function SvgIconMn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c1.467 0 2.873-.264 4.173-.746l.522-11.253L16.173.747A12 12 0 0 0 12 0c-1.468 0-2.874.265-4.174.747L7.304 12l.521 11.253c1.3.482 2.706.746 4.174.746"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A2001D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12c0 5.16 3.257 9.558 7.826 11.254V.747C3.256 2.442 0 6.84 0 12M16.174.746v22.507C20.744 21.558 24 17.16 24 12c0-5.16-3.257-9.558-7.826-11.254"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.783 11.999H5.739v4.174h1.044zM2.609 11.999H1.565v4.174H2.61zM4.174 14.609a1.044 1.044 0 1 0 0-2.088 1.044 1.044 0 0 0 0 2.087M4.174 10.434a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.044M5.218 15.129H3.13v1.043h2.087zM5.218 10.955H3.13V12h2.087zM4.175 6.26l.37 1.137H5.74l-.967.703.369 1.137-.967-.703-.968.703.37-1.137-.968-.703h1.196z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMn;